export default "/images/Resins.webp?a888b9782ab87c638136bcc4cffdfc32";